import React from "react";

export default function Home({ scrollTo }) {
  return (
    <section id="home" className="hero">
      <div className="hero__inner">
        <p className="hero__label">Founder, MemoryAgent</p>
        <h1 className="hero__name">Korey Collazo</h1>
        <p className="hero__description">
          Building the trusted execution layer for desktop agents.
        </p>
        <p className="hero__description-secondary">
          MemoryAgent turns plain-English requests into safe, replayable work on
          macOS, with proof attached.
        </p>
        <div className="hero__signals" aria-label="Key strengths">
          <span className="hero__signal">Verification-first</span>
          <span className="hero__signal">Replayable runs</span>
          <span className="hero__signal">macOS-native</span>
        </div>
        <div className="hero__actions">
          <button className="hero__cta" onClick={() => scrollTo("venture")}>
            Explore MemoryAgent <span className="hero__cta-arrow">&darr;</span>
          </button>
          <a
            className="hero__link"
            href="https://memoryagent.dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit memoryagent.dev <span>&rarr;</span>
          </a>
        </div>
      </div>
    </section>
  );
}
